import { Component, Injector, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { NotificationService } from 'src/app/core/services/notification-data.service';
import { extractLinkPath, isDeepLinkAvailable, isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';

@Component({
  selector: 'laas-bell-notifications-content',
  templateUrl: './bell-notifications-content.component.html',
  styleUrls: ['./bell-notifications-content.component.scss']
})
export class BellNotificationsContentComponent extends SessionBaseComponent implements OnInit {

  title: string = '';
  content: any;
  fileList: any[] = [];
  isFileDialogLoading: boolean = false;
  
  constructor(
    injector: Injector,
    private sanitizer: DomSanitizer,
    private notificationService: NotificationService,
    private route: ActivatedRoute
  ) {
    super(injector);
    this.route.queryParams.subscribe(data => {
      if (data.seqNo) {
        const notification = {
          uuid: data.uuid,
          seqNo: parseInt(data.seqNo),
          isRead: parseInt(data.isRead),
          title: data.title,
          content: data.content,
        };
        this.updateNotificationData(notification);
      }
    });
  }

  async ngOnInit(): Promise<void> {
    const notification = this.routeStateService.getCurrent()?.data;
    this.updateNotificationData(notification);

    if (isDeepLinkAvailable(notification.content)) {
      this.useDeepLinkApproach(notification.content);
    }
  }

  private useDeepLinkApproach(content: string): void {
    const linkPath: any = extractLinkPath(content);
    if (!isNullOrEmpty(linkPath)) {
      window.location.href = linkPath;
    }
  }

  updateNotificationData(notification: any): void {
    if (notification) {
      const isRead = notification.isRead;
      if (isRead.toString() === '0') {

        const req = {
          markType: "SelectedRow",
          seqNos: [ notification.seqNo ],
          uuid: notification.uuid,
        };

        this.notificationService.markRead(req).subscribe({
          next: () => {
            notification.isRead = 1;
            this.notificationService.setUpdateBellNotifyFlag(true);
          }
        });
      }

      this.title = notification.title;
      this.content = this.sanitizer.bypassSecurityTrustHtml(notification.content);

      if (notification.seqNo) {
        this.getNotificationFiles(notification.seqNo);
      }
    }
  }

  transformToSafeUrl(url: string | null) {
    return url ? this.sanitizer.bypassSecurityTrustUrl(url) : '';
  }

  isImageTypeFile(fileType: string): boolean {
    return this.getTypeClass(fileType) === this.getTypeClass("image/*")
  }

  getTypeClass(fileType: string): string {
    return fileType.substring(0, fileType.indexOf('/'));
  }

  getNotificationFiles(notifyInformationSeqNo: any): void {
    this.isFileDialogLoading = true;
    this.notificationService.getNotifyInformationFiles(notifyInformationSeqNo).subscribe({
      next: (response: any) => {
        this.fileList = [...response].map((file: any) => {
          return {
            fileName: file.fileName,
            fileType: file.docType,
            fileDataUrl: `data:${file.docType};base64,${file.fileBase64s}`,
          }
        });
      },
      complete: () => {
        this.isFileDialogLoading = false;
      }
    });
  }
}
